// @flow
import 'babel-polyfill';
import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import * as Validations from 'validations/HomieValidations';
import BackButton from 'components/renter_application/BackButtonComponent';
import InputComponent from 'components/shared/InputComponent';
import SelectComponent from 'components/shared/SelectComponent';
import ScreeningParamsActions from 'actions/ScreeningParamsActions';
import ScreeningParamsStore from 'stores/ScreeningParamsStore';
import { SCREENING_PARAMS } from 'utils/Constants';
import $_ from 'jquery';

const HomeApplicaationReferenceForm = styled.div`
  padding-bottom: 20px;
`;

type PropsType = {
  homeApplication: any,
  onChange: (any, any) => void,
  onPrevStep: () => void,
  onCancel: () => void
};

type ReferenceType = {
  bussines_name: string,
  name: string,
  last_name: string,
  second_last_name: string,
  email: string,
  relationship: string,
  mobile_phone: string,
  address: {
    street: string,
    ext_number: string,
    int_number: string,
    neighborhood: string,
    town: string,
    state: string,
    country: string,
    zip: string
  }
};

type StateType = {
  relationship: Array<any>,
  references: Array<ReferenceType>
};

export default class ReferencesContentComponent extends React.Component<
  PropsType,
  StateType
> {
  constructor(props: PropsType) {
    super(props);
    this.state = {
      relationship: [],
      references: this.defaultValues()
    };
  }

  defaultValues = (): Array<ReferenceType> => {
    const propsReferences = this.props.homeApplication.references;
    const number_of_references = this.props.homeApplication
      .number_of_references;
    const references = [];

    for (let i = 0; i < number_of_references; i++) {
      const reference = propsReferences[i] || {};
      references.push(this._buildReferenceObject(reference));
    }

    return references;
  };

  _buildReferenceObject = (data: any) => {
    return {
      bussines_name: _.get(data, 'bussines_name') || '',
      name: _.get(data, 'name') || '',
      last_name: _.get(data, 'last_name') || '',
      second_last_name: _.get(data, 'second_last_name') || '',
      email: _.get(data, 'email') || '',
      mobile_phone: _.get(data, 'mobile_phone') || '',
      relationship: _.get(data, 'relationship') || '',
      address: {
        street: _.get(data, 'address.street') || '',
        ext_number: _.get(data, 'address.ext_number') || '',
        int_number: _.get(data, 'address.int_number') || '',
        neighborhood: _.get(data, 'address.neighborhood') || '',
        town: _.get(data, 'address.town') || '',
        state: _.get(data, 'address.state') || '',
        country: _.get(data, 'address.country') || '',
        zip: _.get(data, 'address.zip') || ''
      }
    };
  };

  componentDidMount() {
    ScreeningParamsActions.getScreeningParams({
      name: SCREENING_PARAMS.Relationship_moral
    });
  }

  componentWillMount() {
    ScreeningParamsStore.addChangeListener(this.onScreeningParamsChange);
  }

  componentWillUnmount() {
    ScreeningParamsStore.removeChangeListener(this.onScreeningParamsChange);
  }

  onScreeningParamsChange = () => {
    let relationship = [];
    const relation = ScreeningParamsStore.getScreeningParam(
      SCREENING_PARAMS.Relationship_moral
    );
    if (typeof relation !== 'undefined')
      relation.map(item =>
        relationship.push({ value: item.slug, label: item.name })
      );
    this.setState({ relationship });
  };

  submitSuccess = (values: {}): void => {
    this.props.onChange(values);
  };

  onValidChange = (
    value: string,
    path: string,
    callback?: () => void,
    index: number
  ) => {
    this.setState(prevState => {
      prevState.references[index] = _.set(
        prevState.references[index],
        path,
        value
      );
      return prevState;
    }, callback);
  };

  handleSubmit = async (event: any) => {
    event.preventDefault();
    const references = this.state.references;
    this.executeValidations();
    let response = await this.isFieldsValidated();
    if (response) {
      const submitValue = {
        step: 'references',
        serialized_references: references.map(reference => {
          return this._buildReferenceObject(reference);
        })
      };
      this.submitSuccess(submitValue);
    } else {
      $_('html, body, #Wrapper').animate({ scrollTop: 0 }, 500);
    }
  };

  executeValidations = () => {
    document.querySelectorAll('form input').forEach(el => {
      el.focus();
      el.blur();
    });
  };

  isFieldsValidated = async (): boolean => {
    let rerrors = await this.resolveAfter();
    return rerrors === 0;
  };

  resolveAfter = async () => {
    var l = new Promise(resolve => {
      setTimeout(() => {
        var lengthError = document.querySelectorAll('form .error-message')
          .length;
        resolve(lengthError);
      }, 250);
    });
    return l;
  };

  renderReferenceForm = (reference: any, index: number) => {
    const { relationship } = this.state;

    const onValueChange = (_v: string, _p: string, _c?: () => void) => {
      this.onValidChange(_v, _p, _c, index);
    };

    return (
      <HomeApplicaationReferenceForm key={index}>
        <RenterApp.Title>Cuéntanos más de la empresa</RenterApp.Title>
        <InputComponent
          name="bussines_name"
          value={reference?.bussines_name}
          type="text"
          placeholder="Nombre de la empresa"
          onValueChange={onValueChange}
          schema={Validations.RequiredFieldSchema}
        />
        <RenterApp.Title>Datos de tu referencia</RenterApp.Title>
        <SelectComponent
          name="relationship"
          placeholder="Relación"
          minSize={4}
          options={relationship}
          value={reference.relationship}
          isSearchable={false}
          onValueChange={onValueChange}
          schema={Validations.RequiredFieldSchema}
        />
        <InputComponent
          name="last_name"
          value={reference.last_name}
          type="text"
          placeholder="Apellido(s)"
          onValueChange={onValueChange}
          schema={Validations.RequiredNameSchema}
        />
        <InputComponent
          name="name"
          value={reference.name}
          type="text"
          placeholder="Nombre (s)"
          onValueChange={onValueChange}
          schema={Validations.RequiredNameSchema}
        />
        <InputComponent
          name="email"
          value={reference.email}
          type="email"
          placeholder="Correo"
          onValueChange={onValueChange}
          schema={Validations.RequiredEmailSchema}
        />
        <InputComponent
          name="mobile_phone"
          value={reference.mobile_phone}
          type="text"
          placeholder="Teléfono"
          onValueChange={onValueChange}
          schema={Validations.PhoneNumberWithCountryCodeSchema}
          maxLength={24}
        />
        <RenterApp.EndSectionSpace />
      </HomeApplicaationReferenceForm>
    );
  };

  render() {
    const { references } = this.state;

    const renderedReferences = references.map((reference, index) => {
      return (
        <div key={index}>
          {references.length > 1 && <h3>Referencia {index + 1}</h3>}
          {this.renderReferenceForm(reference, index)}
        </div>
      );
    });

    return (
      <RenterApp.AppTabContainer>
        <RenterApp.BackButtonContainer onClick={this.props.onPrevStep}>
          <BackButton text={'Ingresos'} />
        </RenterApp.BackButtonContainer>
        <RenterApp.AppTabForm>
          <form onSubmit={this.handleSubmit}>
            {renderedReferences}
            <RenterApp.SubmitButton type="submit">
              Siguiente
            </RenterApp.SubmitButton>
          </form>
        </RenterApp.AppTabForm>
        <RenterApp.CancelAppButton onClick={this.props.onCancel}>
          Cancelar aplicación
        </RenterApp.CancelAppButton>
      </RenterApp.AppTabContainer>
    );
  }
}
